import React from 'react';
import del from '../Res/Icon/delete.png';
import edit from '../Res/Icon/edit.png';
import recover from '../Res/Icon/recover.png';

const EnterpriseGroup = ({ company, disabled, onDelete, onEdit, deleteMode, onRecover }) => {
  const { _id: id, name, memberCompanies, monitoredDevices, managedDevices, memberUsers } = company;
  return (
    <tr>
      {/* <td>{id}</td> */}
      <td>{name}</td>
      <td>{company?.managementCompany?.name}</td>
      <td>{company?.managementCompany?.epikCustomerId}</td>
      <td>{memberUsers?.length || 0}</td>
      <td>{memberCompanies?.length || 0}</td>
      <td>{managedDevices || 0}</td>
      <td>{monitoredDevices || 0}</td>
      <td style={{ minWidth: '100px' }}>
        {!deleteMode ? (
          <img onClick={() => onEdit(company)} className="actions-icon" src={edit} alt="edit" />
        ) : (
          <img onClick={() => onRecover(id)} className="actions-icon" src={recover} alt="recover" />
        )}
        <img
          onClick={() => {
            onDelete(id);
          }}
          className="actions-icon"
          src={del}
          alt="delete"
        />
      </td>
    </tr>
  );
};

export default EnterpriseGroup;
